'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.reduce = reduce;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reduce(c, fn, init) {
  if (!c) {
    return [];
  } else {
    if (c.length != null) return c.reduce(fn, init);
    if ((typeof c === 'undefined' ? 'undefined' : (0, _typeof3.default)(c)) === 'object') {
      return (0, _keys2.default)(c).map(function (k) {
        return c[k];
      }).reduce(fn, init);
    }
  }
}